import {
  CertificateStatus,
  GooglePlacesAddress,
  McCarerFor,
} from '@/lib/apis/types'

export const RequestStatusMap: {
  [key in CertificateStatus]: string
} = {
  APPROVED: 'Approved',
  PENDING_PAYMENT: 'Pending Payment',
  PENDING_APPROVAL: 'Pending Approval',
  PAYMENT_PROCESSING: 'Processing Payment',
  CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
  INVALIDATED: 'Invalidated',
  PENDING_RESCHEDULE: 'Pending Reschedule',
  PENDING_ACTION: 'Pending Action',
}

export const CarerForMap: {
  [key in McCarerFor]: string
} = {
  FamilyMember: 'Family member',
  Partner: 'Partner',
  Housemate: 'Housemate',
}

export const GENDERS = {
  M: 'Male',
  F: 'Female',
}

export type SearchParams = Record<string, string | string[] | undefined>

export type DetailedAddress = GooglePlacesAddress & {
  formattedAddress: string
}

export type SelfDispenseFilterValue = 'all' | 'self' | 'pharmacy'
